/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cdo_CancelInputs */

const vi_cdo_cancel = /** @type {(inputs: Cdo_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Huỷ`)
};

/**

* @param {Cdo_CancelInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const cdo_cancel = /** @type {((inputs?: Cdo_CancelInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cdo_CancelInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_cdo_cancel(inputs)
});